package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatToFullDateTime
import core.dateformat.utils.stringToLocalDateTime
import com.essntl.core.utils.utils.capitalizeFirstLetter
import com.essntl.core.waypoint.domain.models.WaypointLogs
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun WaypointStatusItem(
    waypointLogs: WaypointLogs,
    showDivider: Boolean = true,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.Top,
    ) {
        Row(
            verticalAlignment = Alignment.Top,
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                EsSmallOutlineIconButton(
                    iconRes = when (waypointLogs.status) {
                        WaypointLogs.Status.OPENED -> EsIcons.Eye
                        WaypointLogs.Status.SENT -> EsIcons.Send
                        WaypointLogs.Status.CREATED -> EsIcons.ContactIcon
                        WaypointLogs.Status.DELIVERED -> EsIcons.Messages
                        WaypointLogs.Status.ERROR -> EsIcons.Trash
                        else -> EsIcons.Edit
                    },
                    onClick = {},
                )

                if (showDivider)
                    VerticalDivider(
                        thickness = 1.dp,
                        color = MaterialTheme.esColorScheme.primary,
                        modifier = Modifier
                            .height(50.dp)
                            .padding(vertical = 1.spacing),
                    )
            }

            Spacer(modifier = Modifier.width(1.5.spacing))

            waypointLogs.status?.name
                ?.lowercase()
                ?.capitalizeFirstLetter()
                ?.let {
                    Text(
                        text = it,
                        style = MaterialTheme.esTypography.c1Medium13.copy(
                            color = if (waypointLogs.status == WaypointLogs.Status.ERROR)
                                MaterialTheme.esColorScheme.textError else
                                MaterialTheme.esColorScheme.textPrimary,
                        ),
                    )
                }
        }

        Text(
            text =
            stringToLocalDateTime(waypointLogs.createdAt)
                ?.formatToFullDateTime()
                .orEmpty(),
            style = MaterialTheme.esTypography.c1Medium13.copy(
                color = MaterialTheme.esColorScheme.textSecondary,
            ),
        )
    }
}